<template>
    <div class="text-xs-center">
        <template v-if="!confirmLogout">
            <p>Are you sure you want to log out?</p>
            <p>You are logged in as {{$firebaseClient.firebaseUser.email}}</p>
            <p>Clicking 'Yes, log me out' will cause you to be logged out of <strong>all</strong> of our websites.</p>
            <v-btn @click="cancelLogout">No, take me back</v-btn>
            <v-btn @click="handleLogout" color="error">Yes, log me out</v-btn>
        </template>
        <template v-else>
            <p>Ok, please wait while we make sure you are logged out of all of our sites.</p>
            <logout-client v-for="(client, key) in clients" :key="key" :client="client" :client_id="key" @clientLogoutComplete="clientLoaded" @clientLogoutError="clientError"></logout-client>
            <p v-if="allSucceeded">Thanks for waiting, we will log you out in <strong class="success--text">{{logoutTimeout}}</strong> seconds.</p>
            <!--Use a timeout on each link before displaying an error. This could be tricky if the app has to cold start-->
            <!--Retry mechanism? if error-->
            <div class="mt-3"><contact-support></contact-support></div>
        </template>
    </div>
</template>

<script>
  import LogoutClient from '@/views/auth/LogoutClient'
  // TODO: For anyone readying this, DO NOT SEND MULTIPLE LOGOUT REQUESTS TO THE SAME DOMAIN. Doing so will transmit the
  // site cookie, and because each client is access asynchronously they will overwrite each other. That's two hours of
  // my life I won't get back :@
  export default {
    name: 'logout',
    components: {LogoutClient},
    props: {
      systemConfig: {
        required: true
      }
    },
    data () {
      return {
        confirmLogout: false,
        logoutHint: null,
        clientStatuses: {
          // members: {
          //   success: false,
          //   error: false,
          //   timeout: null
          // },
          // myguild: {
          //   success: false,
          //   error: false,
          //   timeout: null
          // },
          admin: {
            success: false,
            error: false,
            timeout: null
          },
          // judging: {
          //   success: false,
          //   error: false,
          //   timeout: null
          // }
        },
        loggingOut: false,
        logoutTime: 5,
        logoutTimeout: 5,
        logoutTimer: null
      }
    },
    computed: {
      clients () {
        // TODO: need to filter the clients based on the user role
        return this.systemConfig.ssoClients
      },
      allSucceeded () {
        // if (!this.clientStatuses.members.success) return false
        // if (!this.clientStatuses.myguild.success) return false
        if (!this.clientStatuses.admin.success) return false
        // if (!this.clientStatuses.judging.success) return false
        return true
      },
      timerProgress () {
        return (this.logoutTimeout / this.logoutTime) * 100
      },
      cancelUrl () {
        return this.$router.currentRoute.query.cancelUrl
      }
    },
    mounted () {
    },
    methods: {
      clientLoaded (clientKey) {
        this.clientStatuses[clientKey].success = true
        this.clientStatuses[clientKey].error = false
        this.clientStatuses[clientKey].loading = false
        if (this.clientStatuses[clientKey].timeout) {
          clearTimeout(this.clientStatuses[clientKey].timeout)
        }
      },
      clientError (clientKey) {
        this.clientStatuses[clientKey].error = true
        this.clientStatuses[clientKey].success = false
        this.clientStatuses[clientKey].loading = false
        if (this.clientStatuses[clientKey].timeout) {
          clearTimeout(this.clientStatuses[clientKey].timeout)
        }
      },
      handleLogout () {
        this.confirmLogout = true
      },
      cancelLogout () {
        if (this.cancelUrl) {
          window.location.href = this.cancelUrl
        } else {
          this.$router.go(-1)
        }
      },
      logoutUser (logoutHint) {
        console.log('[LOGOUT]: Logging out user')
        if (logoutHint) {
          this.logoutHint = logoutHint
        }
        this.$firebaseClient.logoutUser()
          .catch((error) => {
            console.log(`[LOGOUT]: Failed to logout user: ${error}`)
          })
      }
    },
    watch: {
      allSucceeded () {
        const self = this
        self.logoutTimeout = 5
        self.logoutTimer = setInterval(() => {
          if (!self.logoutTimeout) {
            clearTimeout(self.logoutTimer)
            self.logoutUser()
          } else {
            self.logoutTimeout--
          }
        }, 1000)
      }
    }
  }
</script>

<style lang="scss">
</style>
